import 'firebase/firestore';
import 'firebase/functions';

import { region, app } from '../model/FirebaseConfig';

export const firestore = app.firestore();
export const functions = app.functions(region);
